<template>
    <div class="total-student-wrap">
        <div class="row justify-content-center">
            <div 
                class="col-lg-12 col-sm-6 col-md-4"
                v-for="total in totals"
                :key="total.id"
            >
                <div class="single-total d-flex justify-content-between align-items-center">
                    <div>
                        <span :class="total.class">{{total.title}}</span>
                        <h2>{{total.number}}</h2>
                    </div>
                    <router-link to="/" class="view-btn">
                        View All
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import totalStudent from './totalStudent.json'

export default {
    name: 'TotalStudentWrap',
    data (){
        return {
            totals: totalStudent,
        }
    }
}
</script>

<style lang="scss">
.single-total {
	background: #FFFFFF 0% 0% no-repeat padding-box;
	box-shadow: 0px 2px 15px #00000008;
	border: 1px solid #EBF1FF;
	border-radius: 20px;
	padding: 25px 20px;
	margin-bottom: 24px;
	span {
		display: block;
		font-size: 13px;
		font-weight: 500;
		color: #4FCB8D;
		margin-bottom: 5px;
		&.color-1765fd {
			color: #1765fd;
		}
		&.color-5c31d6 {
			color: #5c31d6;
		}
	}
	h2 {
		font-size: 30px;
		margin-bottom: 0;
	}
	.view-btn {
		font-size: 12px;
		background: #FFFFFF 0% 0% no-repeat padding-box;
		border: 1px solid #BCC2CF;
		border-radius: 10px;
		padding: 8px 10px;
		&:hover {
			background-color: var(--main-color);
			color: var(--white-color);
			border-color: var(--main-color);
		}
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .single-total {
        padding: 15px;
        border-radius: 10px;
        h2 {
            font-size: 20px;
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .single-total {
        padding: 15px;
        h2 {
            font-size: 20px;
        }
    }
}
</style>